import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/SuccessCases/Header';
import MainContent from 'components/SuccessCases/MainContent';

export default function successCases() {
  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>Learn with the ones who already discovered the power of infographics</title>

        <meta
          key="description"
          name="description"
          content="These articles are using Mind the Graph to create beautiful graphical abstracts as a way of getting more citations and being remembered by many people."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
